<template>
  <el-col :span="24"  :style="{width:width,heigth:height,fontSize:fontSize,fontFamily:chartConfig.fontFamily,color:chartConfig.color,
    textAlign:align,verticalAlign:valign,letterSpacing:letterSpacing,fontWeight:chartConfig.fontWeight,
    backgroundColor:getBackgroundColor,backgroundImage:getBackgroundImage,
    borderRadius:getBorderRadius}">
    <div style="display: inline-block;" v-if="chartConfig.isShowCurrentTq=='1'">
      {{ currentTq }}
    </div>
    <div style="display: inline-block;" v-if="chartConfig.isShowCurrentWd=='1'">{{ currentWd }}℃</div>
    <!-- <div style="display: inline-block;" v-if="chartConfig.isShoWMinWd=='1'">{{ minWd }}</div>
    <div style="display: inline-block;" v-if="chartConfig.isShoWMaxWd=='1'">{{ maxWd }}</div> -->
    <div style="display: inline-block;" v-if="chartConfig.isShoWCurrentFl=='1'">{{ currentFl }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeek1=='1'">{{ week1 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeek2=='1'">{{ week2 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeek3=='1'">{{ week3 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekTq1=='1'">{{ weekTq1 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekTq2=='1'">{{ weekTq2 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekTq3=='1'">{{ weekTq3 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekWdMin1=='1'">{{ weekWdMin1 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekWdMax1=='1'">{{ weekWdMax1 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekWdMin2=='1'">{{ weekWdMin2 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekWdMax2=='1'">{{ weekWdMax2 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekWdMin3=='1'">{{ weekWdMin3 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekWdMax3=='1'">{{ weekWdMax3 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekFl1=='1'">{{ weekFl1 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekFl2=='1'">{{ weekFl2 }}</div>
    <div style="display: inline-block;"  v-if="chartConfig.isShowWeekFl3=='1'">{{ weekFl3 }}</div>
  </el-col>

</template>

<script>
  export default{
    props: {
      width: {
        type: String,
        default: '300px'
      },
      height: {
        type: String,
        default: '30px'
      },
      apiService:{
      },
      chartConfig: {
    		type: Object,
    		default: function(){
          return {
          fontSize:24,
          fontFamily:'微软雅黑',
          name:'标准标题',
          cityId:'',
          color:'#fff',
          align:'center',
          verticalAlign:'middle',
          letterSpacing:8,
          fontWeight:'normal',
          cityId:'110100',
          isShowCurrentTq:'1',
          isShowCurrentWd:'1',
          // isShoWMinWd:'0',
          // isShoWMaxWd:'0',
          isShoWCurrentFl:'0',
          isShowWeek1:'0',
          isShowWeek2:'0',
          isShowWeek3:'0',
          isShowWeekTq1:'0',
          isShowWeekTq2:'0',
          isShowWeekTq3:'0',
          isShowWeekWdMin1:'0',
          isShowWeekWdMin2:'0',
          isShowWeekWdMin3:'0',
          isShowWeekWdMax1:'0',
          isShowWeekWdMax2:'0',
          isShowWeekWdMax3:'0',
          isShowWeekFl1:'0',
          isShowWeekFl2:'0',
          isShowWeekFl3:'0',
        }
        }
    	}
    },
    data(){
      return {
        currentTq:'晴',
        currentWd:'24',
        // minWd:'10',
        // maxWd:'10',
        currentFl:'东北风<1级',
        week1:"星期一",
        week2:"星期二",
        week3:"星期三",
        weekTq1:'晴',
        weekTq2:'晴',
        weekTq3:'晴',
        weekWdMin1:'10',
        weekWdMax1:'10',
        weekWdMin2:'10',
        weekWdMax2:'10',
        weekWdMin3:'10',
        weekWdMax3:'10',
        weekFl1:'东北风<1级',
        weekFl2:'东北风<1级',
        weekFl3:'东北风<1级',
        timer:null
      }
    },
    computed:{
      getBackgroundColor(){
        return this.chartConfig.backgroundColor
      },
      getBackgroundImage(){
        return this.chartConfig.backgroundImage
      },
      getBorderRadius(){
        return this.chartConfig.borderRadius
      },
      letterSpacing(){
        return this.chartConfig.letterSpacing+"px"
      },
      fontSize(){
        return this.chartConfig.fontSize+"px"
      },
      align(){
        if(!this.chartConfig.align){
          return 'left'
        }
        return this.chartConfig.align
      },
      valign(){
        if(!this.chartConfig.verticalAlign){
          return 'middle'
        }
        return this.chartConfig.verticalAlign
      },
      configAndApi(){
        const config={
          apiService:this.apiService,
          config:this.chartConfig.cityId
        }
        return config;
      }
    },
    mounted() {
      this.getWeather()
      let that=this
      if(this.timer==null){
        this.timer=setInterval(function(){
          that.getWeather()
        },1000*10*60)
      }

    },
    watch:{
      configAndApi: {
        handler(newValue, oldValue) {
          this.getWeather()
        },
        deep: true
    },
   },
   beforeDestroy() {
     if(!this.timer){
       clearInterval(this.timer)
       this.timer=null
     }
   },
   methods:{
     getWeather(){
       console.info("weather get");
       if(this.apiService && this.chartConfig.cityId){
           this.apiService(this.chartConfig.cityId).then((res)=>{
             this.currentWd = res.result.now.temp
             this.currentTq = res.result.now.text
             // this.minWd=res.result.now.low
             // this.maxWd=res.result.now.high
             this.currentFl=res.result.now.wind_dir+" "+res.result.now.wind_class
             this.week1=res.result.forecasts[0].week
             this.week2=res.result.forecasts[1].week
             this.week3=res.result.forecasts[2].week
             this.weekTq1=res.result.forecasts[0].text_day
             this.weekTq2=res.result.forecasts[1].text_day
             this.weekTq3=res.result.forecasts[2].text_day

             this.weekWdMin1=res.result.forecasts[0].low
             this.weekWdMax1=res.result.forecasts[0].high

            this.weekWdMin2=res.result.forecasts[1].low
            this.weekWdMax2=res.result.forecasts[1].high

            this.weekWdMin3=res.result.forecasts[2].low
            this.weekWdMax3=res.result.forecasts[2].high
             this.weekFl1=res.result.forecasts[0].wd_day+"  "+res.result.forecasts[0].wc_day
             this.weekFl2=res.result.forecasts[1].wd_day+"  "+res.result.forecasts[1].wc_day
             this.weekFl3=res.result.forecasts[2].wd_day+"  "+res.result.forecasts[2].wc_day

           })
       }
     }
   }
  }
</script>

<style scoped="scoped" lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/text/Weather.vue